
import './assets/css/app.css'

import { useEffect, useMemo } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { connect } from "react-redux"
import { isBrowser } from "react-device-detect"

import { ConfigProvider, App, theme } from 'antd'
import esES from 'antd/locale/es_ES'
import loadable from '@loadable/component'

import { authAutoSignIn } from "@actions"
import AntdAppProvider from '@components/AppProvider'
import PrivateRoute from '@containers/PrivateRoute'

const Login = loadable(() => import("./containers/Login"))
const Home = loadable(() => isBrowser ? import("./containers/Home") : import("./containers/Mobile"))

const defaultToken = {
    fontSize: 15,
    colorPrimary: '#311111',
    borderRadius: 5,
    colorLink: '#240c0c',
    fontWeightStrong: 500,
    colorBorderSecondary: '#dadada',
    colorTextPlaceholder: 'rgba(0, 0, 0, 0.85)',
    colorTextQuaternary: 'rgba(0, 0, 0, 0.55)',
    colorTextSecondary: 'rgba(0, 0, 0, 0.85)',
    colorBorder: '#cacaca',
    colorSplit: '#cacaca',
    controlItemBgActive: '#f3dede',
    controlItemBgActiveHover: '#e8c4c4',
    controlItemBgHover: '#f9eeee',

    colorPrimaryBg: '#decaca',       // fondo suave primario
    colorPrimaryBorder: '#311111',   // borde
    colorPrimaryHover: '#5a2222',    // hover
    colorPrimaryActive: '#311111',   // active

    cyan: "rgba(65, 114, 135)",
    green: "#208820",
    blue: "#417287"
}

const defaultComponents = {
    Form: {
        itemMarginBottom: 12
    },
    Message: {
        borderRadiusLG: 5,
        boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
    },
    Layout: {
        siderBg: '#311111',
        lightSiderBg: '#311111'
    },
    Card: {
        headerBg: '#decaca',
        colorBorderSecondary: '#cacaca',
        colorTextDescription: 'rgba(0, 0, 0, 0.85)'
    },
    Menu: {
        subMenuItemSelectedColor: '#ffffff',
        darkItemBg: '#311111',
        darkSubMenuItemBg: '#311111'
    },
    Descriptions: {
        labelBg: '#decaca',
        colorBorder: '#cacaca',
    },
    Table: {
        headerBg: '#decaca',
        rowSelectedBg: '#f3dede',
        rowSelectedHoverBg: '#e8c4c4',
        rowHoverBg: '#f9eeee',
        borderColor: '#cacaca',
    },
    List: {
        headerBg: '#decaca',
    },
    Tree: {
        titleHeight: 26,
        directoryNodeSelectedColor: "#000",
        directoryNodeSelectedBg: '#decaca'
    }
}

const AppMra = ({ onAutoSignIn, init }) => {
    const messageConfig = {
        top: 2,
        duration: 5,
        maxCount: 3,
    }

    const notificationConfig = {
        placement: 'bottomRight',
        top: 10,
        maxCount: 3,
        duration: 5
    }

    const themes = useMemo(() => ({
        algorithm: theme.defaultAlgorithm,
        token: defaultToken,
        components: defaultComponents
    }), [])


    useEffect(() => {
        onAutoSignIn()
    })

    return (
        <div key="light">
            <ConfigProvider locale={esES} theme={themes}>
                <App message={messageConfig} notification={notificationConfig}>
                    <AntdAppProvider />
                    <Router>
                        {init && (
                            <Routes>
                                <Route path="/auth/:authType/:id?" element={<Login />} />
                                <Route
                                    path="/*"
                                    element={
                                        <PrivateRoute>
                                            <Home />
                                        </PrivateRoute>
                                    }
                                />
                            </Routes>
                        )}
                    </Router>
                </App>
            </ConfigProvider>
        </div>
    )
}

const mapStateToProps = state => ({
    init: state.ui.init,
})
const mapDispatchToProps = dispatch => ({
    onAutoSignIn: () => dispatch(authAutoSignIn())
})

export default connect(mapStateToProps, mapDispatchToProps)(AppMra)
